export const defaultExerciseData = {
	id: "1",
	activities: [
		"Trabalho de Flexibilidade",
		"Trabalho de Coordenação",
		"Massagem",
		"Circuito Aeróbico",
		"Circuito de RML",
		"Andar",
		"Força Dinâmica",
		"Força Pura",
		"Força Explosiva",
		"Pedalar",
		"Correr",
		"Hidroginástica",
	],
	strengthExercises: [
		{
			exercises: [
				"Panturrilha em pé",
				"Panturrilha sentado",
				"Panturrilha no Leg-press",
			],
			groupName: "Panturrilha",
		},
		{
			exercises: [
				"Meio Agachamento",
				"Agachamento",
				"Agachamento no Hack",
				"Leg-press horizontal",
				"Leg-press vertical",
				"Extensão de pernas",
				"Flexão de pernas",
				"Afundo",
				"Cadeira adutora",
				"Cadeira abdutora",
				"Levantamento Terra",
				"Mesa para Glúteos",
			],
			groupName: "Coxas e gluteos",
		},
		{
			exercises: [
				"Crunch com rotação",
				"Flexão lateral tronco",
				"Abd. infra-umbilical",
				"Crunch banco/polia",
			],
			groupName: "Abdomen",
		},
		{
			exercises: [
				"Supino reto",
				"Supino inclinado",
				"Supino decli/canad.",
				"Crucifixo reto",
				"Crucifixo inclinado",
				"Crucifixo declinado",
				"Pec deck (voador)",
				"Crossover",
				"Pullover",
			],
			groupName: "Peito",
		},
		{
			exercises: [
				"Barra fixa",
				"Pulley alto post.",
				"Pulley alto anterior",
				"Remada sentado",
				"Remada unilateral",
				"Remada curvada",
				"Hiperextensão lombar",
			],
			groupName: "Costas",
		},
		{
			exercises: [
				"Desenvolv. p/ frente",
				"Desenvolv. p/ trás",
				"Desenvolv. halteres",
				"Elevação lateral",
				"Elevação frontal",
				"Remada alta",
				"Encolhimento ombros",
			],
			groupName: "Ombro",
		},
		{
			exercises: [
				"Rosca direta(barra)",
				"Rosca simult.(halt.)",
				"Rosca concentrada",
				"Rosca Scott",
				"Rosca inversa",
			],
			groupName: "Biceps",
		},
		{
			exercises: [
				"Tríceps pulley alto",
				"Tríceps na testa",
				"Tríceps coice(Kickb.)",
				"Supino fechado",
				"Tríceps francês",
				"Tríceps unilateral",
			],
			groupName: "Triceps",
		},
		{
			exercises: ["Rosca punho", "Rosca punho inversa", "Adução/Abdução punho"],
			groupName: "Antebraço",
		},
		{ exercises: [], groupName: "Outros" },
	],
	aerobicExercises: [
		"Correr",
		"Andar",
		"Pedalar",
		"Nadar",
		"Hidroginástica",
		"Remar",
		"Ginástica",
	],
	standardizedSeries: [
		{
			exercises: [
				"Mesa para Glúteos",
				"Extensão de pernas",
				"Cadeira adutora",
				"Cadeira abdutora",
				"Flexão de pernas",
				"Meio Agachamento",
				"Tríceps pulley alto",
				"Supino fechado",
			],
			groupName: "Feminino",
		},
	],
	personalTrainerId: "1",
};
